<template>
  <div
    :class="[
      $style.wrap,
      isPick && $style.pick,
      isOutcome && $style.outcome,
      isCorrect === true && $style.correct,
      isCorrect === false && $style.incorrect,
      variant === 'bronze' && $style.bronze
    ]"
    :aria-label="ariaLabel"
  >
    <div :class="$style.inner">
      <template v-if="team">
        <span :class="$style.left">
          <team-icon :team="team" size="sm" />
          <span :class="$style.name">{{ team.name }}</span>
        </span>
      </template>
      <template v-else>
        <ui-icon
          name="plus"
          :class="$style.placeholderIcon"
          aria-hidden="true"
        />
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import TeamIcon from '../../common/TeamIcon.vue'
import UiIcon from '@/ui-core/components/icon/index.vue'
import type { PickemTeam } from '../../../types'

defineOptions({ name: 'PickemBracketWinner' })

const props = withDefaults(
  defineProps<{
    team: PickemTeam | null
    isPick?: boolean
    isOutcome?: boolean
    isCorrect?: boolean | null
    variant?: 'gold' | 'bronze'
  }>(),
  {
    isPick: false,
    isOutcome: false,
    isCorrect: null,
    variant: 'gold'
  }
)

const ariaLabel = computed(() => {
  if (!props.team) {
    return props.variant === 'bronze'
      ? 'Победитель матча за 3-е место'
      : 'Победитель турнира'
  }
  return props.team.name
})
</script>

<style lang="scss" module>
.wrap {
  box-sizing: border-box;
  height: 4.6em;
  padding: 2px;
  border-radius: 0.4em;
  outline: 0.2em solid #ffda35;
  outline-offset: 0.4em;

  &.bronze {
    outline-color: #cd7f32;
  }
}

.inner {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0 1.2em;
  border-radius: calc(0.4em - 2px);
  background-color: color-get(--root-rgb-control-default-bg);
}

.left {
  display: flex;
  align-items: center;
  gap: 0.8em;
  min-width: 0;
  width: 100%;
}

.name {
  @include typo-get(headline-s);
  color: color-get(--root-rgb-text-1);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.placeholderIcon {
  width: 3.2em;
  height: 3.2em;
  color: color-get(--root-rgb-text-2);
}

.pick .inner {
  border: 1px solid color-get(--root-rgb-accent-2);
}

.outcome:not(.pick) .inner {
  border: 1px solid color-get(--root-rgb-system-warning);
}

.correct .inner {
  border: 1px solid color-get(--root-rgb-system-success);
  background-color: color-get(--root-rgb-system-success, 0.06);
}

.incorrect .inner {
  border: 1px solid color-get(--root-rgb-system-error);
  background-color: color-get(--root-rgb-system-error, 0.06);
}
</style>
